import React,{useEffect,useState,useRef} from 'react';
import ReactLoading from 'react-loading';
import Header from '../../components/common/Header';
import PageBreadcrumbs from '../../components/common/PageBreadcrumbs';
import {useNavigate,useLocation,Link} from 'react-router-dom';
import {getStudentTransactions,getSelectedDetail,getStudentResultNumber, getStudentExamResultDetail} from '../../actions/StudentAction'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faDownload} from '@fortawesome/free-solid-svg-icons';
import ResultOverviewSection from '../../components/TallentexResult/ResultOverviewSection';
import RelativeComparision from '../../components/TallentexResult/RelativeComparision';
import SubjectScore from '../../components/TallentexResult/SubjectScore';
import YourRank from '../../components/TallentexResult/YourRank';
import QuestionStatics from '../../components/TallentexResult/QuestionStatics';
import CompetiveSuccessIndex from '../../components/TallentexResult/CompetiveSuccessIndex';
import SubjectTopicAnalysis from '../../components/TallentexResult/SubjectTopicAnalysis';
import DifficultyLevelTable from '../../components/TallentexResult/DifficultyLevelTable';
import DiffcultyLevelChart from '../../components/TallentexResult/DifficultyLevelChart';
import AttemptedDifficultyLevelChart from '../../components/TallentexResult/AttemptedDifficultyLevelChart';
import { useReactToPrint } from 'react-to-print';
import Logo from '../../assets/images/logo/logo.png'
import ResultUserDetail from '../../components/TallentexResult/ResutlUserDetail';
import { getStudentFee } from '../../actions/StudentAction';

const ResultPdf = (props) => {

  const navigate = useNavigate()
  const location=useLocation();
  const[transactions,setTransaction]=useState([])
  const[detail,setDetail]=useState(undefined)
    const [resultDetail,setResultDetail] = useState()
    const [studentResult,setStudentResult] = useState();
    const [loading,setLoading] = useState(true)
    const [feeDetail,setFeeDetail] = useState({});
    const componentRef = useRef();

  useEffect(() => {
    sessionStorage.getItem('userDetail') ?  navigate('/pdf-download') : navigate('/login');
   
    if(location&& location.state!==null){
      const {detail}=location.state
      const userId=detail.id!==undefined &&detail.id

      getSelectedDetail(userId).then((res) => {
        setDetail(res.data);
        setLoading(false)
    });

    getStudentExamResultDetail(detail !== undefined && detail.form_num).then((res) => {
        setResultDetail(res.data)
        setLoading(false)
    })

    getStudentFee(detail!==undefined&& detail.id, 1).then(res => {
        setFeeDetail(res.data)
    });
  
  }
  

},[location.state]);

const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    // onPrintError : () => {
    //     let msg = 'Admit Card Download Failed. Please Try Again.'
    //     swal(msg, '', 'error')
    // },
    // removeAfterPrint : () => {
    //     let msg = 'Admit Card Download Failed. Please Try Again.'
    //     swal(msg, '', 'error')
    // },
    documentTitle : 'TALLENTEX Exam Result PDF'
})

const studentSubject = resultDetail !== undefined && resultDetail.subject
const subjectTopics = resultDetail !== undefined && resultDetail.topic
const resultSummary = resultDetail !== undefined && resultDetail.summary

let subjectItem = []
for (let subject in  studentSubject) {
    subjectItem[subject]=studentSubject[subject];
}
let table_counter = 0;
  return (
    <>
     {loading ? <div className="screenLoader"><ReactLoading type={"bars"} width={80}  color={"#20367f"}/></div>:
     <>
    <Header detail={detail}/>
       <section className="pt-5 pb-5 content-section">
          <div className="container">
            <PageBreadcrumbs profileDetailLink={detail} pagename="Download PDF" colFull/>
            <div className="row mt-2 mb-2">
                <div className="col-lg-12">
                    {/* <h3 className='fw-bold mt-0 '>Welocme, {detail !==undefined && detail.name}</h3>
                    <p className='text-muted'>TALLENTEX OVERSEAS 2022 Performance Analysis / CSI</p> */}
                    <button onClick={handlePrint} onAfterPrint className='btn btn-primary pdf-download-btn btn-sm mx-auto'><FontAwesomeIcon icon={faDownload} className="me-2"/>Download PDF</button>
                </div>
            </div>
            <div className='row'  ref={componentRef}>
            <div className='col-lg-12 result_overviewTab'>
                <div className='card p-4'>
                   
                    <div class="tab-content p-0" id="pills-tabContent">
                        {/* Result Overview */}
                        <div class="tab-pane fade show active pdf_competitive_indexWrap" id="pill-overview" role="tabpanel" aria-labelledby="pill-overview-tab">
                            <div className='row'>
                                <div className='col-md-2'>
                                    <div className='text-center'>
                                    <img src={Logo} className=" mb-2 img-fluid" style={{width:150}}/>
                                    </div>
                                    
                                    <h4 className='text-center my-3 fs-18'>Exam Result 2023-24</h4>
                                    <YourRank detail={detail !==undefined && detail}  resultDetail={resultDetail !== undefined && resultDetail} title={false}/>
                                    <div className='result_pdf_sideSmlCotent'>
                                    <h5>What is Overseas Rank?</h5>
                                    <p>Your Overseas rank is amongst the same class students who sat for TALLENTEX 2022 from Overseas
                                        which includes students from Bahrain, Kuwait, Oman, Qatar, Saudi Arabia and United Arab 
                                    Emirates. </p>

                                        <h5>What is India rank?</h5>
                                    <p>Your India rank is a projected rank based on students who sat for TALLENTEX 2023 conducted for Indian students taking into consideration the normalisation for the difficulty level of both the exams. </p>

                                        <h5>What is Competitive Success Index (CSI)?    </h5>
                                    <p>The CSI measure the student's chances of success in forthcoming competitive exams. such as the JEE (Main), JEE (Advanced), NEET (UG) and International Olympiads. </p>
                                    </div>
                                        
                                </div>
                                <div className='col-md-10'>
                                    <ResultUserDetail  detail={detail}/>
                                    {/* {resultDetail !==undefined && resultSummary.cash_prize !== null && 
                                        <div className='cash_prizeWinnerWrap'>
                                        <h5 className='rank_title'>Congratulations you have won {feeDetail!==undefined&& feeDetail.scholarship_percentage}% scholarship and cash reward of Rs {resultDetail !==undefined && resultSummary.cash_prize} amount (if any) based on your TALLENTEX Overseas 2023 Performance. </h5>
                                        </div>
                                    } */}

                                    <div className='pdf_sectionTitle_contain'>
                                        <h4>Performance Analysis / CSI</h4>
                                    </div>

                                    <ResultOverviewSection resultDetail={resultDetail !== undefined && resultDetail}/>
                                    <div className='card p-3 mb-3'>
                                    <CompetiveSuccessIndex detail={detail !== undefined && detail} resultDetail={resultDetail !== undefined && resultDetail}/>
                                    </div>
                                    

                                    <RelativeComparision  resultDetail={resultDetail !== undefined && resultDetail}/>

                                </div>

                                <div className='col-md-10 mt-5 text-center mx-auto pdf_footer_content'>
                                    <p><strong>Disclaimer : </strong> The utmost care has been taken while preparing and uploading the TALLENTEX OVERSEAS 2023 result 
                                     and other information, yet ALLEN  Career Institute reserves all rights to rectify inadvertent errors, if any</p>
                                   
                                </div>
                                <div className='afterFirst_pageBreak'></div> 
                                <div id='topicAnalysis_break' ></div>
                                <div className='row'>
                                    <div className='col-lg-12'>
                                    
                                    <div className='pdf_sectionTitle_contain pdf-mt'>
                                        <h4>Subject Score / Percentage and Question Static</h4>
                                    </div>
                                    </div>
                                    <div className='col-md-8'>
                                    <SubjectScore resultDetail={resultDetail !== undefined && resultDetail} showTitle={false}/>
                                    </div>
                                    <div className='col-md-4'>
                                    <QuestionStatics  studentResult={resultDetail !==undefined && resultDetail}/>
                                    </div>
                                </div>
                                
                                    
                                
                                <div className='row mt-4'>
                                    <div className='col-lg-12'>
                                    <div className='pdf_sectionTitle_contain pdf-mt'>
                                        <h4>Topic Analysis</h4>
                                     
                                    </div>
                                         {
                                           
                                            subjectItem !== undefined && subjectItem.map((item,index) => {
                                                if(index==0 || index==2)
                                                {
                                                  return  <div id='breakTopicTable'><SubjectTopicAnalysis subjectIndex={item.fieldvalue} subjectName={item.fieldvalue} studentResult={resultDetail !==undefined && resultDetail}/></div>
                                                }
                                               return <SubjectTopicAnalysis subjectIndex={item.fieldvalue} subjectName={item.fieldvalue} studentResult={resultDetail !==undefined && resultDetail}/>
                                            })
                                         }
                                        {/* Difficulty Level */}
                                        
                                        <div id='difficulty-level'></div> 
                                        <div className='pdf_sectionTitle_contain'>
                                        <h4>Question Difficulty Levels</h4>
                                        </div>
                                        <div className='card p-4'>
                                            <DifficultyLevelTable  studentResult={resultDetail !==undefined && resultDetail}/>

                                            <div className='container'>
                                                <div className='row'>
                                                    <div className='col-md-4 mt-5'>
                                                        <div className='widget_title d-flex align-items-center justify-content-between'>
                                                            <h3>Question Difficulty Levels</h3>
                                                        </div>
                                                        <DiffcultyLevelChart studentResult={resultDetail !==undefined && resultDetail}/>
                                                    </div>
                                                    <div className='col-md-2'></div>
                                                    <div className='col-md-4 mt-5'>
                                                        <div className='widget_title d-flex align-items-center justify-content-between'>
                                                            <h3>Attempted Questions</h3>
                                                        </div>
                                                        <AttemptedDifficultyLevelChart studentResult={resultDetail !==undefined && resultDetail}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                                
                        </div>
                </div>
            </div>
            </div>
            

        </div></div>

        </section>
        </>
}
    </>
  )
}

export default ResultPdf
